(() => {
  const mediumSelector = '[data-blog-utm-medium]';

  const normalizeHost = (host) => host.toLowerCase().replace(/^www\./, '');

  const getShopHosts = (config) => {
    const hosts = new Set([normalizeHost(window.location.hostname)]);
    const shopUrl = config.dataset.blogUtmShopUrl;
    const permanentDomain = config.dataset.blogUtmPermanentDomain;

    if (shopUrl) {
      try {
        hosts.add(normalizeHost(new URL(shopUrl).hostname));
      } catch (error) {
        // Ignore an invalid shop URL and continue with the current host.
      }
    }

    if (permanentDomain) {
      hosts.add(normalizeHost(permanentDomain.split(':')[0]));
    }

    return hosts;
  };

  const appendTracking = (anchor, campaign, shopHosts) => {
    const rawHref = anchor.getAttribute('href');
    const medium = anchor.closest(mediumSelector)?.dataset.blogUtmMedium;

    if (!rawHref || !medium || rawHref.startsWith('#')) return;

    let parsedUrl;

    try {
      parsedUrl = new URL(rawHref, document.baseURI);
    } catch (error) {
      return;
    }

    if (!['http:', 'https:'].includes(parsedUrl.protocol)) return;
    if (!shopHosts.has(normalizeHost(parsedUrl.hostname))) return;

    const hasUtmParameter = [...parsedUrl.searchParams.keys()].some((key) =>
      key.toLowerCase().startsWith('utm_')
    );

    if (hasUtmParameter) return;

    const hashIndex = rawHref.indexOf('#');
    const hrefWithoutHash = hashIndex === -1 ? rawHref : rawHref.slice(0, hashIndex);
    const hash = hashIndex === -1 ? '' : rawHref.slice(hashIndex);
    let separator = '?';

    if (hrefWithoutHash.includes('?')) {
      separator = hrefWithoutHash.endsWith('?') || hrefWithoutHash.endsWith('&') ? '' : '&';
    }

    const trackingQuery = new URLSearchParams({
      utm_source: 'blog',
      utm_medium: medium,
      utm_campaign: campaign,
    }).toString();

    anchor.setAttribute('href', `${hrefWithoutHash}${separator}${trackingQuery}${hash}`);
  };

  const initialize = (root = document) => {
    const config = document.querySelector('[data-blog-utm-campaign]');
    const campaign = config?.dataset.blogUtmCampaign;

    if (!config || !campaign) return;

    const shopHosts = getShopHosts(config);
    const containers = [];

    if (root instanceof Element && root.matches(mediumSelector)) {
      containers.push(root);
    }

    containers.push(...root.querySelectorAll(mediumSelector));

    containers.forEach((container) => {
      container.querySelectorAll('a[href]').forEach((anchor) => {
        appendTracking(anchor, campaign, shopHosts);
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
